module.exports = __webpack_public_path__ + "static/media/change-speed.a6c1a78d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/myaccount/Dashboard/change-speed.svg
 ** module id = 1327
 ** module chunks = 0
 **/